import React from 'react'
import PropTypes from 'prop-types'

import { PICTURE_DEBUG, SERVER_URL } from 'Global/constants'
import { hasPermission } from 'Components/Permissions/utils'

import { Image, Label, Popup } from 'semantic-ui-react'
import { Link } from 'react-router'

import * as rugHelpers from 'Global/Helpers/rugHelpers'

const RugCardPicture = ({ isMasterpiece, fromPage, noRibbon, rug, userPermissions }) => {
  const isAllowedToSeeStatus = hasPermission('rug.field.status', userPermissions)

  return (
    <Link to={{ pathname: `/rug/${rug.id}`, query: { fromPage } }}>
      {isMasterpiece && <Popup content="Masterpiece" size="mini" trigger={<Label color="blue" corner="right" icon="magic" />} />}

      <Image
        label={
          !noRibbon &&
          isAllowedToSeeStatus && {
            color: rugHelpers.getStatus(rug).color,
            content: rugHelpers.getStatus(rug).text,
            icon: rugHelpers.getStatus(rug).icon,
            ribbon: true,
          }
        }
        src={PICTURE_DEBUG ? PICTURE_DEBUG : `${SERVER_URL}${rug.picture}`}
        fluid
      />
    </Link>
  )
}

RugCardPicture.propTypes = {
  fromPage: PropTypes.string.isRequired,
  noRibbon: PropTypes.bool,
  rug: PropTypes.object.isRequired,
  userPermissions: PropTypes.array.isRequired,
}

RugCardPicture.defaultProps = {
  noRibbon: false,
}

export default RugCardPicture
